import React, { memo, forwardRef } from "react";
const SvgConjugate = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M7.594 25.914a1 1 0 001.32-.508L16 9.462l7.087 15.944a1 1 0 101.827-.812l-8-18a1 1 0 00-1.827 0l-8 18a1 1 0 00.507 1.32z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgConjugate.displayName = "SvgConjugate";
const MemoForwardRef = memo(SvgConjugate);
export default MemoForwardRef;
